import '../styles/page.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function Ci() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <section id="contact-banner">
        <div className="page-banner-bg">
          <div className="m-auto page-banner-container">
            <h2 data-aos="fade-right" data-aos-duration="700" data-aos-once="true">
              CI 소개
            </h2>
            <p
              className="color-caption fs-base"
              data-aos="fade-right"
              data-aos-duration="700"
              data-aos-once="true"
              data-aos-delay="200"
            >
              TAKE의 로고 및 브랜드 요소를 확인할 수 있는 공간입니다.
            </p>
          </div>
        </div>
      </section>
      <section id="intro-ci">
        <div className="ci-title">
          <div className="line-hor"></div>
          <p className="fs-base fw-bold color-primary">COMPANY CI</p>
        </div>
        <div className="img-ci-logo"></div>
        <div className="ci-container m-auto">
          <div className="ci-text">
            <div>
              <p className="fs-lg fw-bold">
                끊임없이 변화하는 기술 흐름 속에서도
                <br />
                중심을 지키는 IT파트너
              </p>
              <p className="fs-md color-caption mt-28">
                테이크의 CI는 브랜드 철학을 바탕으로 설계되었습니다.
                <br />
                그라데이션을 활용한 로고는 유연하면서도 진보적인 기술의 흐름을 상징하며,
                <br className="mo-not-br" />
                직선과 간결한 곡선으로 이루어진 형태는 신뢰와 전문성의 의미를 전달합니다.
              </p>
            </div>
            <div className="ci-divider ml-40"></div>
            <div className="take-color-content">
              <div className="take-color-box"></div>
              <div className="take-color-text">
                <div>
                  <p>take blue</p>
                  <p className="color-caption mt-8">
                    C:93 M:76 Y:0 K:0
                    <br />
                    R:0 G:76 B:186
                  </p>
                </div>
                <div>
                  <p>take blue</p>
                  <p className="color-caption mt-8">
                    C:93 M:76 Y:0 K:0
                    <br />
                    R:0 G:76 B:186
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="product-ci">
            <div className="ci-title">
              <div className="line-hor"></div>
              <p className="fs-base fw-bold color-primary">PRODUCT CI</p>
            </div>
            <div className="product-ci-content">
              <div className="product-ci-item">
                <div className="product-ci-box">
                  <img src="./images/logo-uxbooster.svg" className="img-40" />
                </div>
                <div className="product-ci-box">
                  <img src="./images/logo-uxboard.svg" className="img-40" />
                </div>
                <div className="product-ci-box">
                  <img src="./images/logo-uxcreator.svg" className="img-40" />
                </div>
              </div>
              <div className="product-ci-item">
                <div className="product-ci-box">
                  <img src="./images/logo-aichanger.svg" className="img-48" />
                </div>
                <div className="product-ci-box">
                  <img src="./images/logo-gems.svg" className="img-48" />
                </div>
                <div className="product-ci-box">
                  <img src="./images/logo-epro.svg" className="img-48" />
                </div>
              </div>
            </div>
            <div className="ci-text">
              <div>
                <p className="fs-md color-caption">
                  테이크에서 제공하는 제품들은 고유의 브랜드 로고를 가지고 있으며,&nbsp;
                  <br className="mo-none" />
                  이는 통일된 아이덴티티 안에서 각 제품의 기능과 열할을 시각적으로 표현합니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Ci;
